import { SVGProps } from 'react';

const SmileyKindHappy = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.6323 14C6.42702 14 6.23453 14.0984 6.11602 14.264C5.99752 14.4295 5.96774 14.6415 6.03617 14.8326C6.92813 17.3298 9.31826 19 12 19C14.6817 19 17.0719 17.3298 17.9638 14.8326C18.0323 14.6415 18.0025 14.4295 17.884 14.264C17.7655 14.0984 17.573 14 17.3677 14L6.6323 14Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx={8.5} cy={8.5} r={0.5} fill="var(--bloko-icon-color, var(--bloko-icon-color-default))" />
        <circle cx={15.5} cy={8.5} r={0.5} fill="var(--bloko-icon-color, var(--bloko-icon-color-default))" />
        <circle
            cx={8.5}
            cy={8.5}
            r={0.5}
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle
            cx={15.5}
            cy={8.5}
            r={0.5}
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SmileyKindHappy;
